import React from "react";

export const RouteNotFound = () => {
    return (
        <div>
            404
        </div>
    )
}
